import { useEffect } from 'react';
// mismo breakpoint que el full-screen de Bot.module.css
const MOBILE_QUERY = '(max-width: 767px)';
export const useMobileScrollLock = (isLocked) => {
    useEffect(() => {
        if (!isLocked || typeof window === 'undefined')
            return;
        const mediaQuery = window.matchMedia(MOBILE_QUERY);
        const { body, documentElement } = document;
        const previous = { body: body.style.overflow, html: documentElement.style.overflow };
        const apply = () => {
            body.style.overflow = mediaQuery.matches ? 'hidden' : previous.body;
            documentElement.style.overflow = mediaQuery.matches ? 'hidden' : previous.html;
        };
        apply();
        mediaQuery.addEventListener('change', apply);
        return () => {
            mediaQuery.removeEventListener('change', apply);
            body.style.overflow = previous.body;
            documentElement.style.overflow = previous.html;
        };
    }, [isLocked]);
};
